import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import axios from 'libs/axios'
import * as serviceWorker from './serviceWorker'
import 'core-js/es'  
import 'react-app-polyfill/ie9'  
import 'react-app-polyfill/stable'
// redux
import { Provider } from 'react-redux'
import storeCallback from '@redux'
import { PersistGate } from 'redux-persist/integration/react'
const { store,persistor } = storeCallback()
require('dotenv').config({ path: '.env' })
React.Component.prototype.axios = axios
ReactDOM.render(<Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <App />
    </PersistGate>
</Provider>,
document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
